import ReactECharts from "echarts-for-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { transpose } from "underscore";
import { isoTimeToLocalString } from "../../Trends/trendUtil";
import { meanByIndex } from "../utils";



export default function OccupancyLineChart({ occupancyEventData, timeAggType, localTimeZone }) {
    const { t } = useTranslation();
    const timestamps = useMemo(
        () => (occupancyEventData?.timestamps ? [...occupancyEventData.timestamps] : []),
        [occupancyEventData]
    );

    const data = useMemo(() => {
        if (!occupancyEventData) return [];

        // amalgamate by location 
        const locationPercentagesByPoint = {};// { <location name>: [[occupancy percentage values by timestamp]] }

        occupancyEventData.points_data.forEach((point) => {
            if (!locationPercentagesByPoint[point.metadata.location]) {
                locationPercentagesByPoint[point.metadata.location] = [];
            }

            locationPercentagesByPoint[point.metadata.location].push([...point.values]);
        })

        const meansbyLocationAndTimestamp = Object.entries(locationPercentagesByPoint).map(([location, percentagesByPoint]) => {
            const averagePercentagesPerTimestamp = meanByIndex(percentagesByPoint);
            return { metadata: { location }, values: averagePercentagesPerTimestamp };
        });


        return meansbyLocationAndTimestamp

    }, [occupancyEventData]);

    const options = useMemo(() => {
        const dimensions = ["timestamps"]
        const matrix = [["timestamp", ...timestamps]]
        const series = []

        data.forEach((location, i) => {
            let percentageValues = location.values.map(value => value * 100);
            dimensions.push(i.toString())
            matrix.push([i.toString(), ...percentageValues])
            series.push({
                name: location.metadata.location,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                    width: 3
                },
                encode: {
                    x: 'timestamp',
                    y: i.toString()
                }

            })
        })

        const source = transpose(matrix)


        return {
            dataset: {
                source: source,
                dimensions: dimensions,
            },
            tooltip: {
                confine: true,
                trigger: "axis",
                valueFormatter: (value) =>
                    typeof value == "number" ? value.toLocaleString(navigator.language, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) : value,
                axisPointer: {
                    label: {
                        formatter: (params) => isoTimeToLocalString(params.value, timeAggType, localTimeZone)
                    }
                }
            },
            grid: {
                top: '4%',
                left: '4%',
                containLabel: true,
                right: '5%',
                bottom: 30
            },
            legend: {
                show: true,
                bottom: 0,
                left: "center",
                symbol: 'none',
                type: 'scroll',
                width: '80%',
                height: 200,
                itemGap: 20,
            },
            xAxis: {
                type: 'time',
                silent: false,
            },
            yAxis: {
                min: (value) => {
                    return value.min
                },
                minInterval: 1,
                axisLabel: {
                    formatter: function (value) {
                        return Math.ceil(value).toString() + "%";
                    }
                },
            },
            series: series,
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif"
            },

        }
    }, [data, timestamps, timeAggType, localTimeZone])

    return (
        <ReactECharts option={options} notMerge={true} lazyUpdate={false} />
    )

}